<template>
  <div class="order-row">
    <div class="flex-col bottom">
      <div class="flex-col">
        <span class="store_name">{{
          order.store && order.store.storeName
        }}</span>
        <span class="order_id">{{ order.order_id }}</span>
      </div>
      <div class="price-container">
        <span v-if="order.payment" class="sale-price">
          {{ product.payment.price | currency }}</span
        >
      </div>
      <span>{{
        `store.${order.store && order.store.storeName}` | translate
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderRow",
  props: { order: Object },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.order-row {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.image-container {
  position: relative;
  margin-bottom: 0.5rem;
  cursor: pointer;

  .material-icons {
    padding: 0.5rem;
    position: absolute;
    font-size: $font-base;

    @media (min-width: $breakpoint-md) {
      font-size: $font-m;
    }

    &.remove {
      left: 0;
      top: 0;
    }

    &.cart {
      bottom: 0;
      right: 0;
      border-radius: 50%;
      box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
      margin: 0.375rem;
      background-color: $brand-white;
    }

    &.check {
      color: $brand-salmon;
      border-radius: 50%;
      box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
      margin: 0.375rem;
    }
  }
}

.flex-col {
  flex: 1;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.size-select-container {
  display: none;

  &.visible {
    display: flex;
  }
}

.bottom {
  span {
    text-overflow: ellipsis;
    font-size: $font-xs;
    margin-bottom: 0.25rem;
  }

  .store_name {
    font-family: "Lora";
    font-size: $font-xs;
  }

  .order_id {
    font-size: $font-xs;
    font-family: "Montserrat-Bold";
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price-container {
    margin-top: -0.25rem;
    margin-bottom: 0.125rem;
  }

  .sale-price {
    font-weight: bold;
    color: $gyra-red;
    margin-right: 0.25rem;
  }
}
</style>
